import "./styles/audits/audit-forms.css";
import "./styles/audits/look-for.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles/base/global.css"; // ✅ Ensure CSS is loaded

ReactDOM.createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
